<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="refresh()"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-md-6
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover
            thead.thead-light
              tr
                th(width="25%")
                  span {{ $tc('ui.key', 1) }}
                th.text-center(width="19%")
                  span {{ $tc('ui.value', 1) }}
                th.text-center(width="18%" v-if="isEditAccess")
                  span {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="settingList.length == 0")
                td(:colspan="isEditAccess ? '5' : '4'").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in settingList")
                tr(v-if="item.setting_key != 'free_credit'")
                  td
                    template(v-if="item.setting_key == 'min_deposit'")
                      span(:title='$t("ui.minimum_deposit")') {{ $t("ui.minimum_deposit") }}
                    template(v-else-if="item.setting_key == 'min_withdrawal'")
                      span(:title='$t("ui.minimum_withdrawal")') {{ $t("ui.minimum_withdrawal") }}
                    template(v-else-if="item.setting_key == 'max_withdrawal'")
                      span(:title='$t("ui.maximum_withdrawal")') {{ $t("ui.maximum_withdrawal") }}
                    template(v-else)
                      span(:title='$t("ui." + item.setting_key, { currency: getCurrencyCode })') {{ $t("ui." + item.setting_key, { currency: getCurrencyCode }) }}
                  td.text-center
                    template(v-if="['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(item.setting_key)")
                      template(v-if="item.setting_value")
                        span.font-weight-bold.badge.badge-success(:title='$t("ui." + item.setting_value)') {{ $t('ui.on') }}
                      template(v-else)
                        span.font-weight-bold.badge.badge-danger(:title='$t("ui." + item.setting_value)') {{ $t('ui.off') }}
                    template(v-else)
                      span.font-weight-bold(:title="$helpers.isNumeric(item.setting_value) == true ? $n(item.setting_value, 'integer') : item.setting_value") {{ $helpers.isNumeric(item.setting_value) == true ? $n(item.setting_value, 'integer') : item.setting_value }}
                  td.text-center(v-if="isEditAccess")
                    span
                      a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdate(item)" :title="$t('ui.update')")

      .col-md-6
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover
            thead.thead-light
              tr
                th(width="20%")
                  span {{ $tc('ui.key', 1) }}
                th(width="20%")
                  span {{ $tc('ui.value', 1) }}
                th(width="20%")
                  span {{ $tc('ui.remark', 1) }}
                th.text-center(width="10%")
                  span {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="settingList2.length == 0")
                td(colspan="4").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in settingList2")
                td
                  span(:title='$t("ui." + item.setting_key)') {{ $t("ui." + item.setting_key) }}
                td
                  template(v-if="['payment_setting'].includes(item.setting_key)")
                    span(:title='item.setting_value') {{ $t("ui.payment_" + item.setting_value.toLowerCase()) }}
                  template(v-else-if="['turnover_rebate'].includes(item.setting_key)")
                    span(:title='item.setting_value') {{ item.setting_value == 'VIP TIER' ? $t("ui.turnover_rebate_1") : $t("ui.turnover_rebate_2") }}
                  template(v-else)
                    span(:title='item.setting_value') {{ item.setting_value }}
                td
                  span(:title='item.remark') {{ item.remark }}
                td.text-center
                  span(v-if="isEditAccess")
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdate2(item)" :title="$t('ui.update')")

    updateoperatorsetting(ref="updateoperatorsetting" :item="editSelectedSetting" :exchangePointRate="exchangePointRate" @clicked="afterUpdate" @failed="handleFailed")
    updateoperatorsetting2(ref="updateoperatorsetting2" :item="editSelectedSetting2" @clicked="afterUpdate2" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import updateoperatorsetting from "@/components/system/updateOperatorSetting.vue";
import updateoperatorsetting2 from "@/components/system/updateOperatorSetting2.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    updateoperatorsetting,
    updateoperatorsetting2
  },
  data: () => ({
    loading: false,
    feedback: {
      success: true,
      status: ""
    },
    settingList: [],
    settingList2: [],
    editSelectedSetting: null,
    editSelectedSetting2: null,
    exchangePointRate: null
  }),
  computed: {
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_operatorsetting");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
    // this.refresh();
  },
  methods: {
    refresh() {
      this.getOperatorSettingList();
      this.getOperatorSettingList2();
    },
    onUpdate(e) {
      this.editSelectedSetting = e;
      this.exchangePointRate = null
      if(e.setting_key == 'free_coin_min_withdrawal') {
        for(var i = 0; i < this.settingList.length; i++) {
          if(this.settingList[i].setting_key == 'free_coin_per_unit') {
            this.exchangePointRate = this.settingList[i].setting_value
          }
        }
      }

      this.$refs.updateoperatorsetting.$refs.updateOperatorSetting.show();
    },
    afterUpdate: function() {
      this.getOperatorSettingList();
      this.$helpers.showDialog(this.$t("ui.combine.update_operator_setting"), this.$t("message.success"), "success");
    },
    onUpdate2(e) {
      this.editSelectedSetting2 = e;
      this.$refs.updateoperatorsetting2.$refs.updateOperatorSetting2.show();
    },
    afterUpdate2: function() {
      this.getOperatorSettingList2();
      this.$helpers.showDialog(this.$t("ui.combine.update_operator_setting"), this.$t("message.success"), "success");
    },
    getOperatorSettingList: function(item) {
      let url = config.operatorSettingListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getOperatorSettingList2: function(item) {
      let url = config.operatorSettingList2Url();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList2 = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>